import React from 'react';

const About = () => {
    return (
        <div className="fullContainerWidth">

            <div className="dflex">


                <div className="containerp">
                    <h1>À propos</h1>
                    <div className="gallery-grid info-text">

                        <div style={{ gridColumn: 'span 2', gridRow: 'span 2', paddingLeft:'3em', paddingBottom:'6em'}}>
                            <p>Chez To Create, nous croyons en une chose simple mais puissante : chaque idée mérite de prendre vie.
                                Nous sommes là pour accompagner les créateurs, les visionnaires, et les entreprises à transformer leurs concepts en designs uniques, en interfaces intuitives, et en solutions fonctionnelles.

                                Avec une écoute attentive et un savoir-faire multidisciplinaire, nous donnons du sens et de l’âme à vos projets. Que ce soit pour un site web élégant, un objet au design réfléchi, ou une expérience utilisateur mémorable, nous fusionnons créativité et innovation pour atteindre l’essentiel : connecter l’humain à vos réalisations.

                                Pour nous, créer, c’est plus qu’une mission. C’est une démarche qui éveille, élève et inspire.
                                Alors, ensemble, osons concevoir un monde où chaque création raconte une histoire et laisse une empreinte.
                            </p>

                            <h1>
                                To Create
                            </h1>
                            <h4>Donner vie à vos idées, avec sens et émotion.
                            </h4>
                        </div>



                    </div>

                </div>

            </div>

        </div>
    );
};

export default About;
